<template>
    <div class="login mx-auto w-xxl w-auto-xs p-y-md">
        <div class="login-brand">
            <img :src="statics.logo_inverse"
                 alt="."/>
        </div>

        <div class="p-a-md box-color r box-shadow-z1 text-color m-a effect8">
            <div class="m-b text-sm">
                Sign in as <b>Admin</b>
            </div>

            <el-form label-position="top"
                     label-width="300px"
                     :model="user">
                <el-form-item label="Email"
                              prop="email">
                    <el-input id="email"
                              v-model="user.email"
                              autocomplete="on"></el-input>
                </el-form-item>

                <el-form-item label="Password"
                              prop="password">
                    <el-input id="password"
                              :type="showPassword ? 'text' : 'password'"
                              v-model="user.password"
                              autocomplete="on">
                        <template slot="suffix">
                            <i class="el-input__icon password-toggle-icon cursor-pointer"
                               :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
                               @click="togglePasswordVisibility">
                            </i>
                        </template>
                    </el-input>
                </el-form-item>

                <div class="m-b-md">
                    <label class="md-check">
                        <input type="checkbox"
                               v-model="user.remember_me"/><i class="greenish"></i> Keep me signed in
                    </label>
                </div>

                <button type="submit"
                        class="btn greenish btn-block p-x-md"
                        :disabled="loading"
                        @click.prevent="login">
                    <span class="pull-right"
                          :class="{ hidden: !loading }">
                       <i class="material-icons loader">&#xE863;</i>
                    </span>
                    <span class="clear">Sign in</span>
                </button>

                <google-sign-in-button @click.native="loginWithSSO('google')" />
            </el-form>
        </div>
    </div>
</template>

<script>
    import auth from '../auth'
    import googleSignInButton from './widgets/google-sign-in-button'
    import Vue from 'vue'
    import axios from 'axios'
    import VueAxios from 'vue-axios'
    import VueSocialAuth from 'vue-social-auth'

    Vue.use(VueAxios, axios)
    Vue.use(VueSocialAuth, {
        providers: {
            google: {
                clientId: localStorage.getItem('google_client_id'),
                redirectUri: localStorage.getItem('google_redirect'),
                name: 'google',
                requiredUrlParams: ['scope'],
                scope: ['profile', 'email'],
                scopePrefix: 'openid',
                scopeDelimiter: ' ',
                optionalUrlParams: ['access_type', 'prompt', 'state', 'display'],
                accessType: 'offline',
                prompt: 'consent',
                state: 'guard=admin',
                display: 'popup',
                oauthType: '2.0',
                popupOptions: { width: 452, height: 633 }
            }
        }
    })

    export default {
        props: {
            statics: {required: true}
        },

        components: {
            googleSignInButton,
        },

        data() {
            return {
                user: {
                    email: null,
                    password: null,
                    remember_me: null
                },
                loading: false,
                showPassword: false,
            }
        },

        mounted() {
            setInterval(() => {
                let chrome_password = $('#password').val()
                if (chrome_password != '' && this.user.password != chrome_password) {
                    this.user.password = chrome_password
                }
                let chrome_email = $('#email').val()
                if (chrome_email != '' && this.user.email != chrome_email) {
                    this.user.email = chrome_email
                }
            }, 50)
        },

        methods: {
            togglePasswordVisibility() {
                this.showPassword = !this.showPassword
            },

            login(event) {
                event.preventDefault()
                this.loading = true
                auth.login(this.user.email, this.user.password, this.user.remember_me)
                    .then(res => {
                        this.$notify({
                            title: 'Auth',
                            message: res.data.data.msg,
                            type: 'success',
                            showClose: true,
                        })

                        this.loading = false
                        window.location.href = '/admin'
                    })
                    .catch(err => {
                        this.loading = false
                        console.log(err)
                        if (err.response) {
                            if (err.response.status !== 401) {
                                this.$root.handleErrors(err.response)
                            } else {
                                this.$notify({
                                    title: 'Auth',
                                    message: err.response.data.error,
                                    type: 'error',
                                    showClose: true,
                                })
                            }
                        }
                    })
            },

            async loginWithSSO(provider) {
                this.loading = true
                try {
                    const ssoResponse = await this.$auth.authenticate(provider)
                    const ssoLoginResponse = await auth.ssoLogin(provider, ssoResponse)
                    this.$notify({
                        title: 'Auth',
                        message: ssoLoginResponse.data.data.msg,
                        type: 'success',
                        showClose: true,
                    })
                    window.location.href = '/admin'
                } catch (err) {
                    console.error(err)
                    if (err.response?.status !== 401) {
                        this.$root.handleErrors(err.response)
                    } else {
                        this.$notify({
                            title: 'Auth',
                            message: err.response.data.error,
                            type: 'error',
                            showClose: true,
                        })
                    }
                }
                this.loading = false
            }
        }
    }
</script>

<style scoped>
.password-toggle-icon:hover {
    color: #5cb85c;
}
</style>
